import axios from 'axios';

const api = axios.create({
  withCredentials: true,
});

export const loginRedirectPath = () => {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return `/login?redirect=${encodeURIComponent(path)}`;
};

export const loginDestination = () => {
  const path = new URLSearchParams(window.location.search).get('redirect');
  return path?.startsWith('/') && !path.startsWith('//') && !path.includes('\\') ? path : '/';
};

export default api;
